var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { LinkOption } from './controls/link-option-ctrl';
import '../styles/css/react-draft.css';
var OfflineAssessmentEditor = /** @class */ (function (_super) {
    __extends(OfflineAssessmentEditor, _super);
    function OfflineAssessmentEditor(props) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _this = _super.call(this, props) || this;
        var editorState = EditorState.createEmpty();
        var emailHtml = (_b = (_a = props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.offlineAssessmentEmailBody;
        if (typeof emailHtml != 'undefined' && emailHtml) {
            var contentDraftBlock = htmlToDraft(emailHtml);
            if (contentDraftBlock) {
                var contentState = ContentState.createFromBlockArray(contentDraftBlock.contentBlocks);
                editorState = EditorState.createWithContent(contentState);
            }
        }
        _this.state = {
            offlineAssessmentEmailBodyEditorState: editorState,
            offlineAssessmentEmailSubject: (_d = (_c = props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseType) === null || _d === void 0 ? void 0 : _d.offlineAssessmentEmailSubject,
            isOfflineAssessmentEnable: (_f = (_e = props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.currentCaseType) === null || _f === void 0 ? void 0 : _f.isOfflineAssessmentEnable,
            allowOfflineModeExistingPhotoUpload: (_h = (_g = props.caseTypesStore) === null || _g === void 0 ? void 0 : _g.currentCaseType) === null || _h === void 0 ? void 0 : _h.allowOfflineModeExistingPhotoUpload
        };
        return _this;
    }
    Object.defineProperty(OfflineAssessmentEditor.prototype, "getPageLanguage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var language = document.documentElement.lang;
            if (!language)
                language = 'en';
            return language;
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var offlineAssessmentEmailBodyEditorState = this.state.offlineAssessmentEmailBodyEditorState;
            var language = this.getPageLanguage();
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var wrapperClassName = (caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable) && (caseType === null || caseType === void 0 ? void 0 : caseType.allowOfflineModeSendEmailToAgent)
                ? 'text-editor-wrapper'
                : 'text-editor-wrapper-readonly';
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, className: "case-types-tab-panel" }, { children: [_jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(FormControlLabel, { label: "Enable Offline Assessment", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable, onChange: function (e) { return _this.onEnabledFlagChange(e); } }, void 0) }, void 0) }), void 0), _jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(FormControlLabel, { label: "Allow Offline Mode Photo Upload", sx: { whiteSpace: 'nowrap' }, disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable), control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.allowOfflineModeExistingPhotoUpload, onChange: function (e) { return _this.onAllowPhotoUploadFlagChange(e); } }, void 0) }, void 0) }), void 0), _jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(FormControlLabel, { label: "Allow Offline Mode Send Email to Agent", sx: { whiteSpace: 'nowrap' }, disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable), control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.allowOfflineModeSendEmailToAgent, onChange: function (e) { return _this.onAllowOfflineModeSendEmailFlagChange(e); } }, void 0) }, void 0) }), void 0), _jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(TextField, { variant: "outlined", fullWidth: true, disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable) || !(caseType === null || caseType === void 0 ? void 0 : caseType.allowOfflineModeSendEmailToAgent), onChange: function (e) { return _this.onSubmitValueChanged(e); }, value: caseType === null || caseType === void 0 ? void 0 : caseType.offlineAssessmentEmailSubject, label: "Subject" }, void 0) }), void 0), _jsx(Editor, { readOnly: !(caseType === null || caseType === void 0 ? void 0 : caseType.isOfflineAssessmentEnable) || !(caseType === null || caseType === void 0 ? void 0 : caseType.allowOfflineModeSendEmailToAgent), editorState: offlineAssessmentEmailBodyEditorState, wrapperClassName: wrapperClassName, editorClassName: "text-editor", toolbar: {
                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'history', 'image', 'link'],
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: {
                                inDropdown: false,
                                showOpenOptionOnHover: true,
                                defaultTargetOption: '_blank',
                                options: ['link', 'unlink']
                            },
                            history: { inDropdown: true },
                            image: {
                                urlEnabled: true,
                                uploadEnabled: true,
                                alignmentEnabled: true,
                                uploadCallback: undefined,
                                previewImage: false,
                                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                alt: { present: false, mandatory: false },
                                defaultSize: {
                                    height: 'auto',
                                    width: 'auto',
                                },
                                tEnabled: true,
                            }
                        }, toolbarCustomButtons: [_jsx(LinkOption, { editorState: offlineAssessmentEmailBodyEditorState, onChange: function () { return _this.onEditorStateChange(offlineAssessmentEmailBodyEditorState); } }, void 0)], localization: {
                            locale: language
                        }, onEditorStateChange: function (state) { return _this.onEditorStateChange(state); } }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "onEnabledFlagChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { isOfflineAssessmentEnable: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "onAllowOfflineModeSendEmailFlagChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { allowOfflineModeSendEmailToAgent: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "onAllowPhotoUploadFlagChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { allowOfflineModeExistingPhotoUpload: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "onEditorStateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (emailEditorState) {
            var _a, _b;
            this.setState({
                offlineAssessmentEmailBodyEditorState: emailEditorState
            });
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var templateHtml = draftToHtml(convertToRaw(emailEditorState.getCurrentContent()));
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { offlineAssessmentEmailBody: templateHtml });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(OfflineAssessmentEditor.prototype, "onSubmitValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { offlineAssessmentEmailSubject: e.target.value });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    OfflineAssessmentEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], OfflineAssessmentEditor);
    return OfflineAssessmentEditor;
}(React.Component));
export default OfflineAssessmentEditor;
